import { BeckyModel } from '@wix/thunderbolt-becky-root'
import { Data, FetchFn, MetricsReporter } from '@wix/thunderbolt-becky-types'
import { CatharsisArgs, singleTransaction } from '@wix/thunderbolt-catharsis'
import refData from '@wix/document-services-json-schemas/dist/refData.json'
import _ from 'lodash'
import { shapeIdsNode as shapeIds } from './shapeIdsNode'
import { cursorShapeIdsNode as cursorShapeIds } from './cursorShapeIdsNode'
import { BuildSvgUrl, fetchShapes } from './fetchShapes'
import { getInvalidationHandler } from './invalidationHandler'

export const schemas: CatharsisArgs['extensions']['schemas'] = _.mapKeys(refData, (__, key) => key.replace('.json', ''))

const RELEVANT_DATA_MAPS: Array<keyof Data> = [
	'document_data',
	'design_data',
	'component_properties',
	'theme_data',
	'cursor',
]

export const findShapes = (beckyModel: BeckyModel): Array<string> => {
	const set = new Set<string>()
	const onInvalidation = getInvalidationHandler(set)

	const catharsisArgs = {
		onInvalidation,
		extensions: { componentNodes: { shapeIds, cursorShapeIds }, schemas },
		resolveRepeatedItems: true,
	}

	singleTransaction(beckyModel, catharsisArgs, RELEVANT_DATA_MAPS)

	return [...set]
}

export const fetchComponentShapes = (
	beckyModel: BeckyModel,
	fetchFn: FetchFn,
	mediaRootUrl: string,
	buildSvgUrl: BuildSvgUrl,
	metricsReporter: MetricsReporter
): Promise<Record<string, string>> => {
	const shapes = metricsReporter.runAndReport(() => findShapes(beckyModel), 'tb-css-find-shapes')
	return fetchShapes(shapes, fetchFn, mediaRootUrl, buildSvgUrl, metricsReporter)
}
